import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../utils/contexts/UserContext";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import helpers from "../../components/helpers/helpers";
import { getRequest } from "../apiRequests/requestApi";
import Coin from "../../assets/images/coin.svg";


const { apiUrl } = helpers;

export default function Referrals() {
  const { user } = useContext(UserContext) || {};
  const navigate = useNavigate();

  const [referralData, setReferralData] = useState({
    referralCode: "",
    referralLink: "",
    username: "",
  });
  const [loading, setLoading] = useState(true);
  const [earnings, setEarnings] = useState({
    totalEarnings: 0,
    totalEarningsInNaira: "0.00",
    totalReferralRewards: 0,
    monthlyEarnings: [],
    recentTransactions: [],
  });
  const [totalReferrals, setTotalReferrals] = useState(0);
  useEffect(() => {
    // if (!user || !user._id) return;
    async function fetchReferral() {
      try {
        const res = await getRequest("/auth/referral-code");
        if (res && res.success && res.data) {
          setReferralData(res.data);
        } else {
          setReferralData({
            referralCode: user?.referralCode || "",
            referralLink: "",
            username: user?.username || "",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    async function fetchEarnings() {
      try {
        const res = await getRequest("/referrals/earnings");
        if (res && res.success && res.data) {
          setEarnings(res.data);
        }
      } catch (error) {
        // ignore
      }
    }
    async function fetchTotalReferrals() {
      try {
        const res = await getRequest("/referrals/");
        if (res && res.success && Array.isArray(res.data)) {
          setTotalReferrals(res.data.length);
        }
      } catch (error) {
        // ignore
      }
    }
    fetchReferral();
    fetchEarnings();
    fetchTotalReferrals();
  }, []);

  // fallback values if API fails
  const referralCode = referralData.referralCode || user?.referralCode;
  const referralLink = referralData.referralLink || "";
  const referralBonus = user?.referralBonus || 0;
  return (
    <div className="min-h-screen bg-[#130828] flex flex-col items-center py-8 px-4">
      <div className="flex justify-between items-center w-full max-w-md relative mb-8">
        <button
          className="mb-8"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <BsArrowLeft width={20} height={20} color="#fff" />
        </button>
        <h2 className="text-white text-2xl font-bold mb-8">Referrals</h2>
        <div style={{ width: 40 }} /> {/* Spacer */}
      </div>
      <div className="w-full max-w-md bg-[#23203A] rounded-2xl p-6 shadow-lg flex flex-col items-center mb-8">
        <div className="text-white text-lg font-semibold mb-2">
          Your Referral Code
        </div>
        {loading ? (
          <div className="text-white/70 mb-4">Loading...</div>
        ) : (
          <>
            <div className="bg-[#BD3193] text-white font-mono text-xl px-6 py-2 rounded-lg mb-4 select-all">
              {referralCode}
            </div>
            {referralLink && (
              <div className="flex flex-col items-center mb-4 w-full">
                <input
                  className="w-full text-xs text-gray-200 bg-[#1a1a2a] rounded px-2 py-1 mb-2 select-all"
                  value={referralLink}
                  readOnly
                  onClick={(e) => e.target.select()}
                />
                <button
                  className="bg-[#3F9217] text-white px-4 py-2 rounded-lg font-semibold"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `Hey! Join me on Skyboard Games and let's play classic and modern board games together. Sign up using my referral link: ${referralLink} or visit www.skyboardgames.com/ and use my code during registration. Let's compete and have fun!`
                    );
                    alert("Referral link copied to clipboard!");
                  }}
                >
                  Copy Link
                </button>
              </div>
            )}
            <div className="text-white/80 text-xs mb-2">
              Username:{" "}
              <span className="font-bold">
                {referralData.username || user?.username || "N/A"}
              </span>
            </div>
            <button
              className="bg-[#3F9217] text-white px-4 py-2 rounded-lg font-semibold mb-4"
              onClick={() => {
                navigator.clipboard.writeText(
                  `Hey! Join me on Skyboard Games and let's play classic and modern board games together. Visit www.skyboardgames.com and use my referral code: ${referralCode} during registration. Let's compete and have fun!`
                );
                alert("Referral code copied to clipboard!");
              }}
            >
              Copy Code
            </button>
          </>
        )}
        <div className="text-white/80 text-sm mb-2">
          Share your code or link with friends and earn rewards when they join!
        </div>
      </div>
      <div className="w-full max-w-md bg-[#23203A] rounded-2xl p-6 shadow-lg flex flex-col items-center">
        <div className="text-white text-base font-semibold mb-2">
          Referral Stats
        </div>
        <div className="flex justify-between w-full mb-2">
          <span className="text-white/70">Total Referrals:</span>
          <span className="text-white font-bold">{totalReferrals}</span>
        </div>
        <div className="flex justify-between w-full mb-2">
          <span className="text-white/70">Total Earnings             <img src={Coin} alt="Coin" className="w-5 h-5 ml-1 inline" />
:</span>
          <span className="text-white font-bold">
            {earnings.totalEarningsInNaira}
          </span>
        </div>
        <div className="flex justify-between w-full mb-2">
          <span className="text-white/70">Total Rewards:</span>
          <span className="text-white font-bold">
            {earnings.totalReferralRewards}
          </span>
        </div>
      </div>
    </div>
  );
}

